<template>
  <!-- Header -->
  <nav id="topBar" class="topbar-container">
    <div class="topbar-inner">
      <!-- Left side -->
      <div class="topbar-left">
        <button @click="actionSidebar" class="topbar-menu-btn">
          <img class="topbar-logo-img topbar-logo-mobile" :src="brandingLogo || defaultLogo" alt="Logo" />
          <i class="material-icons topbar-menu-icon">menu</i>
        </button>

        <div class="topbar-greeting" v-if="user && user.fullName">
          <span class="greeting-text">Welcome back,</span>
          <span class="greeting-name">{{ user.fullName || 'User' }}</span>
        </div>
      </div>

      <!-- Right side -->
      <div class="topbar-right">
        <!-- Dashboard link -->
        <!-- <router-link v-if="user && $f.getPermission(user,'dashboard')" to="/" class="topbar-icon-btn topbar-hide-mobile" title="Dashboard">
          <i class="material-icons">dashboard</i>
        </router-link> -->

        <!-- Chat Notification (Seller) -->
        <div v-if="typeUser=='Seller'" class="topbar-icon-btn">
          <chatNotify :warehouse="idWharhouse" />
        </div>

        <!-- Live Chat (Admin) -->
        <router-link v-if="typeUser=='Admin'" class="topbar-icon-btn topbar-hide-mobile" to="/livechat" title="Live Chat">
          <i class="material-icons">chat_bubble_outline</i>
        </router-link>

        <!-- Warehouse selector -->
        <div class="topbar-warehouse">
          <Warhouses :user="user" @changeWrahouse="changeWrahouse" :warhouseSelected="warhouseSelected" :idWharhouse="idWharhouse" :sous_idWharhouse="sous_idWharhouse" :sous_warehouses="sous_warehouses" />
        </div>

        <!-- User dropdown -->
        <div class="topbar-user">
          <user-dropdown :user="user" />
        </div>
      </div>
    </div>
  </nav>
  <!-- End Header -->
</template>

<script>
import chatNotify from '../components/livechat/ChatNotify.vue'
import UserDropdown from "@/components/Dropdowns/UserDropdown.vue";
import NotificationDropdown from "@/components/Dropdowns/NotificationDropdown.vue";
import Warhouses from "@//components/Dropdowns/Warhouses.vue";
import Formation from "@//components/Dropdowns/formation.vue";
import defaultLogoImg from "@/assets/shipsen-man.jpg";
export default {
  components: {
    UserDropdown,
    NotificationDropdown,
    Warhouses,
    Formation,
    chatNotify
  },
  props: {
    typeUser: { type: String },
    user: { type: Object },
    warhouseSelected: { type: String },
    idWharhouse: { type: Object },
    sous_idWharhouse: { type: String },
    sous_warehouses: { type: Array },
  },
  mounted() {
    this.loadBranding();
  },
  watch: {
    idWharhouse: {
      handler() { this.loadBranding(); },
      deep: true
    },
    'user.role': {
      handler() { this.loadBranding(); },
      deep: true
    }
  },
  data() {
    return {
      topBar: "bg-white",
      dropdownPopoverShow: false,
      defaultLogo: defaultLogoImg,
      brandingLogo: null,
    };
  },
  methods: {
    actionSidebar() {
      this.$store.dispatch("actionSidebar");
    },
    changeWrahouse: function(val) {
      this.$emit("changeWrahouse", val);
    },
    loadBranding() {
      if (this.idWharhouse && this.user && this.user.role && this.user.role.branding && this.idWharhouse._id) {
        const branding = this.user.role.branding.find(
          b => b.warehouse === this.idWharhouse._id || b.warehouse._id === this.idWharhouse._id || b.country === this.idWharhouse.country
        );
        this.brandingLogo = branding && branding.logo ? branding.logo : null;
      }
    },
  },
};
</script>
<style>
/* TopBar Container */
.topbar-container {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.topbar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  /* padding: 0 20px; */
}

/* Left side */
.topbar-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.topbar-menu-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 4px 12px 4px 12px;
  border-radius: 10px;
  border: none;
  background: #f1f5f9;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}
.topbar-menu-btn:hover {
  background: #e2e8f0;
  color: #1e3a5f;
}
.topbar-logo-img {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  object-fit: cover;
}
.topbar-logo-mobile {
  display: none;
}
@media (max-width: 960px) {
  .topbar-logo-mobile {
    display: block;
  }
}
.topbar-menu-icon {
  font-size: 20px;
}

.topbar-greeting {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}
.greeting-text {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 500;
}
.greeting-name {
  font-size: 15px;
  color: #1e293b;
  font-weight: 600;
}

/* Right side */
.topbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.topbar-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  color: #64748b;
  transition: all 0.2s;
  text-decoration: none;
  cursor: pointer;
}
.topbar-icon-btn:hover {
  background: #f1f5f9;
  color: #3b82f6;
}
.topbar-icon-btn .material-icons {
  font-size: 22px;
}

.topbar-warehouse {
  margin-left: 4px;
}

.topbar-user {
  margin-left: 4px;
}

/* Responsive */
@media (max-width: 768px) {
  .topbar-greeting {
    display: none;
  }
  .topbar-inner {
    padding: 0 8px;
    height: 50px;
  }
  .topbar-right {
    gap: 4px;
  }
  .topbar-icon-btn {
    width: 34px;
    height: 34px;
  }
  .topbar-user {
    margin-left: 0;
  }
  .topbar-warehouse {
    margin-left: 0;
  }
  .topbar-hide-mobile {
    display: none !important;
  }
}

/* Override old styles */
#topBar {
  background: white none repeat scroll 0% 0%;
  color: #1e293b;
  box-shadow: none;
}

.z-9 {
  z-index: 9;
}
.drop-item {
  padding: 0.7rem 1.5rem;
  display: flex;
  align-items: center;
  width: 100%;
  clear: both;
  font-weight: 400;
  text-align: inherit;
  white-space: nowrap;
  background-color: initial;
  border: 0;
}
.dropdown-menu-shipp {
  inset: inherit !important;
  margin: inherit !important;
  transform: inherit !important;
  right: 0 !important;
  left: auto !important;
}
.media {
  display: flex;
  align-items: flex-start;
}
.user-details .media .avatar img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.align-self-start {
  align-self: flex-start !important;
}
.media-body {
  flex: 1;
}
.user-details .media .media-body .user-title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.84);
  margin-bottom: 2px;
}
.user-details .media .media-body .user-subtitle {
  font-size: 13px;
  color: #232323;
  margin-bottom: 0;
}
.profile .title{
    float: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 75%;
}
.profile .details{
    font-size: 12px;
    opacity: 0.4;
    display: block;
    clear: both;
    text-transform: uppercase;
}
</style>
